import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppName, jtString } from '@standardnotes/features';
import { c } from 'ttag';
const ChangeEmailSuccess = () => {
    return (_jsxs("div", { children: [_jsx("div", { className: 'mb-2 font-bold text-info', children: c('B6.Preferences.Account.Info')
                    .t `Your email has been successfully changed.` }), _jsx("p", { children: jtString(c('B6.Preferences.Account.Info')
                    .jt `Please ensure you are running the latest version of ${AppName} on all platforms to ensure maximum compatibility.`) })] }));
};
export default ChangeEmailSuccess;
